import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ZtTextAreaComponent } from './components/atoms/zt-textarea/zt-textarea.component';
import { ZtDropdownComponent } from './components/atoms/zt-dropdown/zt-dropdown.component';
import { ZtSliderComponent } from './components/atoms/zt-slider/zt-slider.component';
import { ZtButtonComponent } from './components/atoms/zt-button/zt-button.component';
import { ZtIconComponent } from './components/atoms/zt-icon/zt-icon.component';
import { ZtToggleComponent } from './components/atoms/zt-toggle/zt-toggle.component';
import { ZtFormControlPipe } from './pipes/zt-form-control.pipe';
import { ZtSanitizePipe } from './pipes/zt-sanitize.pipe';
import { ZtTextInputComponent } from './components/atoms/zt-textinput/zt-textinput.component';
import { ZtLoaderComponent } from './components/molecules/zt-loader/zt-loader.component';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ZtTextAreaComponent,
        ZtDropdownComponent,
        ZtSliderComponent,
        ZtButtonComponent,
        ZtIconComponent,
        ZtTextInputComponent,
        ZtToggleComponent,
        ZtLoaderComponent,
        ZtFormControlPipe,
        ZtSanitizePipe,
    ],
    declarations: [
        ZtTextAreaComponent,
        ZtDropdownComponent,
        ZtSliderComponent,
        ZtButtonComponent,
        ZtIconComponent,
        ZtTextInputComponent,
        ZtToggleComponent,
        ZtLoaderComponent,
        ZtFormControlPipe,
        ZtSanitizePipe,
    ],
    providers: [],
})
export class SharedModule {}
